import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {Skeleton, Typography} from "@mui/material";
import {useTheme} from "../../contexts/theme";

interface CompetitionSkeletonProps{
    skeletonNumber: number;
}

const CompetitionSkeleton: React.FC<CompetitionSkeletonProps> = ({skeletonNumber}) => {
    const theme = useTheme();
    const [skeletons, setSkeletons] = useState<number[]>([]);
    const skeletonStyle = {backgroundColor: theme.palette.white, width: '10%', height: '40px', borderRadius: theme.border.radius.md};

    useEffect(() => {
        setSkeletons(new Array(5).fill(0))
    }, [skeletonNumber]);

    return (
        <Box display="flex" gap={theme.spacing.md}>
            {skeletons.map((skeleton, index) => (
                <Skeleton key={'competitionSkeleton - ' + index} sx={skeletonStyle}/>
            ))}
        </Box>
    )
}

export default CompetitionSkeleton